/**
 * Appearance skin: tactical (default) or retro (current field-edition look).
 * Keep the boot snippet in public/index.html in sync with SKIN_STORAGE_KEY / parseSkin.
 */

export const SKIN_STORAGE_KEY = 'yona-skin';
export const SKIN_TACTICAL = 'tactical';
export const SKIN_RETRO = 'retro';
export const DEFAULT_SKIN = SKIN_TACTICAL;
export const SKINS = [SKIN_TACTICAL, SKIN_RETRO];

export function parseSkin(value) {
  return value === SKIN_RETRO || value === SKIN_TACTICAL ? value : DEFAULT_SKIN;
}

export function readStoredSkin(storage) {
  if (!storage || typeof storage.getItem !== 'function') return DEFAULT_SKIN;
  try {
    return parseSkin(storage.getItem(SKIN_STORAGE_KEY));
  } catch {
    return DEFAULT_SKIN;
  }
}

export function readDocumentSkin(doc) {
  const root = doc?.documentElement;
  if (!root || typeof root.getAttribute !== 'function') return null;
  const attr = root.getAttribute('data-skin');
  return attr === SKIN_RETRO || attr === SKIN_TACTICAL ? attr : null;
}

export function readBootSkin({ document: doc, storage } = {}) {
  const fromDom = readDocumentSkin(doc);
  if (fromDom) return fromDom;
  return readStoredSkin(storage);
}

export function applySkin(skin, { document: doc, storage } = {}) {
  const next = parseSkin(skin);
  const root = doc?.documentElement;
  if (root && typeof root.setAttribute === 'function') {
    root.setAttribute('data-skin', next);
  }
  if (storage && typeof storage.setItem === 'function') {
    try {
      storage.setItem(SKIN_STORAGE_KEY, next);
    } catch {
      // Private mode / quota — attribute still applied.
    }
  }
  return next;
}
